export default __webpack_public_path__ + "static/clutch_2021-23315d1d8a845ab25fa2d60e9bc9d2ca.png";